import ReactPlayer, { ReactPlayerProps } from 'react-player';
import { cn } from '@anytag/shared-utils';
import { Carousel, CarouselProps } from '@anytag/shared-molecules';

export interface MediaPreviewProps {
  isReel?: boolean;
  className?: string;
  images?: readonly string[];
  onTagClick?: (tag: string) => void;
  reactPlayerProps?: ReactPlayerProps;
  currentMediaIndex?: CarouselProps['currSlideIdx'];
  onMediaChange?: CarouselProps['afterChangeHandler'];
  video?: { url?: string; title?: string; tags?: readonly string[] };
}

export const MediaPreview = ({
  video,
  isReel,
  className,
  onTagClick,
  images = [],
  onMediaChange,
  reactPlayerProps,
  currentMediaIndex
}: MediaPreviewProps) => {
  const isVideoPreview = video && !isReel;

  return video || images.length ? (
    <div
      className={cn(
        'relative w-(--image-thumbnail-width) flex-none',
        isVideoPreview ? 'h-(--video-thumbnail-height)' : 'h-(--image-thumbnail-height)',
        className
      )}
    >
      {isVideoPreview ? (
        <>
          <ReactPlayer url={video.url} width="100%" height="100%" {...reactPlayerProps} />
          {video?.tags?.length ? (
            <p className="mt-2 max-h-17.5 overflow-auto text-sm text-blue-70">
              {video.tags.map((tag, index) => (
                <span key={index} className="cursor-pointer not-first-of-type:pl-2" onClick={() => onTagClick?.(tag)}>
                  #{tag}
                </span>
              ))}
            </p>
          ) : null}
          {video?.title ? <p className="mt-2 text-base font-semibold">{video.title}</p> : null}
        </>
      ) : images.length ? (
        <Carousel
          isReel={isReel}
          sources={images}
          className="size-[inherit]"
          currSlideIdx={currentMediaIndex}
          afterChangeHandler={onMediaChange}
          showIcon
        />
      ) : null}
    </div>
  ) : null;
};
